import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-date-option',
  templateUrl: './date-option.component.html',
  styleUrls: ['./date-option.component.scss']
})
export class DateOptionComponent implements OnInit {
  @Input() dateDefualt: string;
  @Input() placeHolder: string = null;//提心信息
  @Output() timeChange: any = new EventEmitter();
  constructor() { }
  dateValue: Date;
  cn: any;
  ngOnInit() {
    this.cn = {
      firstDayOfWeek: 0,
      dayNames: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
      dayNamesShort: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      dayNamesMin: ["日", "一", "二", "三", "四", "五", "六"],
      monthNames: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
      monthNamesShort: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
    };
  }
  getDate(event) {
    let year = (new Date(event)).getFullYear();
    let month;
    ((new Date(event)).getMonth() + 1) < 10 ? month = ("0" + ((new Date(event)).getMonth() + 1)) : month = (new Date(event)).getMonth() + 1
    let day = (new Date(event)).getDate();
    // console.log("day", day);
    let dayTime;
    day <= 9 ? dayTime = '0' + day.toString() : dayTime = day;
    // console.log("dayTime", dayTime);
    let cc = year + '-' + month + '-' + dayTime;
    // console.log('cc', cc);
    this.timeChange.emit(cc);
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user/date-option/date-option.component.ts